import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell } from "./AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {}
    setSent(true);
    setLoading(false);
  };

  return (
    <AuthShell title="Reset hasła" subtitle="Podaj adres e-mail powiązany z kontem">
      {sent ? (
        <div className="text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto mb-3 h-10 w-10 text-emerald-500" />
          <p className="text-sm text-muted-foreground">
            Jeśli konto istnieje, wysłaliśmy link do resetu hasła na podany adres.
          </p>
          <Button asChild variant="link" className="mt-4 text-ztk-blue">
            <Link to="/login" data-testid="forgot-back-link">Powrót do logowania</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-ztk-blue hover:bg-ztk-navy800" data-testid="forgot-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Wyślij link resetujący
          </Button>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/login" className="text-ztk-blue hover:underline">Powrót do logowania</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
